import React from 'react';
import Nav from '../../../components/specific/Navigation';
import { Toaster } from 'react-hot-toast';

const formatUserName = (user) => {
  const fullName = [user?.TERCERO_NOMBRE1, user?.TERCERO_NOMBRE2, user?.TERCERO_APELLIDO1, user?.TERCERO_APELLIDO2].filter(Boolean).join(' ').trim();

  if (fullName) return fullName;
  return user?.TERCERO_RAZON_SOCIAL || 'Sin nombre';
};

const fieldValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

const empleadoLabel = (value) => {
  if (value === 1 || value === '1' || value === true) return 'Si';
  if (value === 0 || value === '0' || value === false) return 'No';
  return '-';
};

const ViewPerfil = ({ perfil, roles, userId, loadingProfile, submittingPassword, passwordForm, onPasswordChange, onSubmitPasswordChange }) => {
  const profileDetails = [
    { label: 'Nombre / Razon social', value: formatUserName(perfil) },
    { label: 'ID tercero', value: perfil?.TERCERO_ID },
    { label: 'Tipo de documento', value: perfil?.DOCUMENTO_TIPO_DESCRIPCION },
    { label: 'Documento', value: perfil?.TERCERO_DOCUMENTO },
    { label: 'Correo', value: perfil?.TERCERO_MAIL },
    { label: 'Telefono / Celular', value: `${fieldValue(perfil?.TERCERO_TEL)} / ${fieldValue(perfil?.TERCERO_CEL)}` },
    { label: 'Direccion', value: perfil?.TERCERO_DIRECCION },
    { label: 'Municipio', value: perfil?.MUNICIPIO_DESCRIPCION },
    { label: 'Codigo municipio', value: perfil?.MUNICIPIO_CODIGO },
    { label: 'Unidad de negocio', value: perfil?.TERCERO_UNI_NEGOCIO },
    { label: 'Es empleado', value: empleadoLabel(perfil?.ES_EMPLEADO) },
    { label: 'Estado', value: perfil?.TERCERO_ESTADO },
    { label: 'Creado', value: perfil?.CREATED_AT },
    { label: 'Actualizado', value: perfil?.UPDATED_AT },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      <Nav />
      <Toaster
        toastOptions={{
          className: 'w-1/2',
        }}
      />

      <div className="mx-auto w-full max-w-7xl p-4 pb-8">
        <div className="lg:grid-cols-12 grid grid-cols-1 gap-4">
          <section className="lg:col-span-8 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b border-gray-200 bg-gradient-to-r from-gray-800 to-gray-700 px-5 py-4 text-white">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-lg font-semibold">Perfil de usuario</h2>
                  <p className="text-xs text-gray-200">Información principal de la cuenta</p>
                </div>
                <span className="rounded-md border border-gray-500 bg-gray-700 bg-opacity-60 px-2.5 py-1 text-xs font-semibold tracking-wide">
                  ID {fieldValue(perfil?.TERCERO_ID)}
                </span>
              </div>
            </div>

            <div className="p-5">
              {loadingProfile ? (
                <div className="py-6 text-sm text-gray-500">Cargando perfil...</div>
              ) : (
                <div className="grid grid-cols-3 gap-3">
                  {profileDetails.map((detail) => (
                    <div
                      key={detail.label}
                      className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2">
                      <p className="text-[11px] uppercase tracking-wide text-gray-500">{detail.label}</p>
                      <p className="text-sm font-semibold text-gray-900">{fieldValue(detail.value)}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </section>

          <div className="lg:col-span-4 flex flex-col gap-4">
            <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
              <h2 className="text-sm font-semibold text-gray-900">Roles</h2>
              <p className="mb-3 text-xs text-gray-500">Accesos asignados al usuario</p>
              {roles.length === 0 ? (
                <p className="text-sm text-gray-500">Sin roles asignados.</p>
              ) : (
                <div className="flex max-h-32 flex-wrap gap-2 overflow-auto pr-1">
                  {roles.map((role, index) => (
                    <span
                      key={`${role?.ROL_ID || role?.ROL_NOMBRE || 'rol'}-${index}`}
                      className="rounded-full border border-yellow-200 bg-yellow-50 px-2.5 py-1 text-xs font-semibold text-yellow-700">
                      {role?.ROL_NOMBRE || `Rol ${role?.ROL_ID || index + 1}`}
                    </span>
                  ))}
                </div>
              )}
            </section>

            <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
              <div className="mb-3 border-b border-gray-100 pb-2">
                <h2 className="text-sm font-semibold text-gray-900">Cambiar contraseña</h2>
                <p className="text-xs text-gray-500">Se cerrará la sesión al actualizar.</p>
                {!userId ? <p className="mt-1 text-xs font-medium text-red-600">No se encontró el identificador del usuario.</p> : null}
              </div>

              <form
                className="flex flex-col gap-2.5"
                onSubmit={onSubmitPasswordChange}>
                <label className="flex flex-col gap-1">
                  <span className="text-xs font-semibold text-gray-600">Contraseña actual</span>
                  <input
                    type="password"
                    className="outline-none h-9 rounded-md border border-gray-300 bg-white px-3 text-sm transition focus:border-gray-500 focus:ring-2 focus:ring-gray-200"
                    value={passwordForm.current_password}
                    onChange={(event) => onPasswordChange('current_password', event.target.value)}
                    disabled={submittingPassword}
                  />
                </label>

                <label className="flex flex-col gap-1">
                  <span className="text-xs font-semibold text-gray-600">Nueva contraseña</span>
                  <input
                    type="password"
                    className="outline-none h-9 rounded-md border border-gray-300 bg-white px-3 text-sm transition focus:border-gray-500 focus:ring-2 focus:ring-gray-200"
                    value={passwordForm.new_password}
                    onChange={(event) => onPasswordChange('new_password', event.target.value)}
                    disabled={submittingPassword}
                  />
                </label>

                <label className="flex flex-col gap-1">
                  <span className="text-xs font-semibold text-gray-600">Confirmar contraseña</span>
                  <input
                    type="password"
                    className="outline-none h-9 rounded-md border border-gray-300 bg-white px-3 text-sm transition focus:border-gray-500 focus:ring-2 focus:ring-gray-200"
                    value={passwordForm.confirm_password}
                    onChange={(event) => onPasswordChange('confirm_password', event.target.value)}
                    disabled={submittingPassword}
                  />
                </label>

                <button
                  type="submit"
                  className="mt-1 h-10 rounded-md bg-gray-900 px-4 text-sm font-semibold text-white transition hover:bg-gray-800 disabled:cursor-not-allowed disabled:opacity-60"
                  disabled={!userId || submittingPassword}>
                  {submittingPassword ? 'Actualizando...' : 'Actualizar contraseña'}
                </button>
              </form>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPerfil;
